/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import styled, { css } from 'styled-components';
import { LinkButton, variables, ContainerSt } from 'app/shared/ui';

import { CartileContainerWrapperSt } from 'app/shared/modules/Cartile/CartileTemplates/CartileContainer/CartileContainer.css';

const {
  variables: { media },
} = variables;
export const ReducedPriceCartilesWrapperSt = styled.div`
  background-color: ${
    /* istanbul ignore next */ ({ theme: { colors } }) => colors.sunbeanLighter
  };

  && .slick-track {
    & ${CartileContainerWrapperSt} {
      padding-right: 12px;
      padding-left: 12px;
    }
  }

  && .slick-arrow.slick-disabled {
    pointer-events: none;
  }
`;

export const ReducedPriceCartilesContainerSt = styled(ContainerSt)`
  width: 100%;
`;

export const LinkButtonSt = styled(LinkButton)`
  display: flex;
  width: 272px;
  margin: 0 auto 40px;

  ${media.md(css`
    width: 278px;
    margin-bottom: 56px;
  `)}

  ${media.lg(css`
    width: 296px;
    margin-bottom: 64px;
  `)}
  
  ${media.xl(css`
    width: 368px;
  `)}
`;

export const LoadingContainerSt = styled.div`
  display: flex;
  width: 100%;
  min-height: 696px;
  align-items: center;
  justify-content: center;
`;
